const COUNTER_DATA = [
  {
    key: '1',
    img: '/assets/dish_1.png',
    label: 'Delicacy',
    value: 250
  },
  {
    key: '2',
    img: '/assets/chef_1.png',
    label: 'Renowed chefs',
    value: 10
  },
  {
    key: '3',
    img: '/assets/team_1.png',
    label: 'Members',
    value: 30
  }
];

export default COUNTER_DATA;